<template>
  <div :class="wrapperClasses">
    <div :class="innerWrapperClasses">
      <div class="flex justify-center">
        <Card class="generic-error-card" :customClasses="finalCardClasses">
          <OopsIllustration class="mx-auto" />
          <h2 class="text-h3 text-center mt-16">{{ title }}</h2>
          <p class="body-1 text-center mt-8">
            <slot>
              There was an error loading this page. Refresh the page to try again or
              <a class="link-secondary underline" href="https://support.sittercity.com/hc/en-us/requests/new" target="_blank"
                >contact us</a
              >
              if the issue continues.
            </slot>
          </p>
          <Button
            :value="buttonValue"
            variant="primary"
            size="medium"
            class="w-full mt-16"
            :to="buttonTo"
            :href="buttonHref"
            @click="handleClick"
          />
        </Card>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Card from '../card/Card.vue';
import OopsIllustration from '../../graphics/illustrations/OopsIllustration.vue';
import Button from '../button/Button.vue';

export default {
  name: 'GenericError',
  components: {
    Card,
    OopsIllustration,
    Button,
  },
  props: {
    layout: {
      type: String,
      default: 'default',
      validator: (value: string) => ['default', 'centered'].includes(value),
    },
    customCardClasses: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'Something went wrong',
    },
    buttonValue: {
      type: String,
      default: 'Try again',
    },
    buttonHref: {
      type: String,
      default: '',
    },
    buttonTo: {
      type: [String, Object],
      default: '',
    },
  },
  computed: {
    wrapperClasses(): string {
      const layoutClassMap = {
        default: '',
        centered: 'flex flex-col min-h-[calc(100vh-200px)]',
      };
      return layoutClassMap[this.layout];
    },
    innerWrapperClasses(): string {
      const layoutClassMap = {
        default: '',
        centered: 'flex-1 flex items-center justify-center pt-16',
      };
      return layoutClassMap[this.layout];
    },
    finalCardClasses(): string {
      if (this.customCardClasses) return this.customCardClasses;

      const layoutClassMap = {
        default: 'max-w-488 p-32',
        centered: 'max-w-488 p-32 box-shadow-sm',
      };
      return layoutClassMap[this.layout];
    },
  },
  methods: {
    handleClick() {
      if (this.buttonHref || this.buttonTo) return;

      this.reloadPage();
    },
    reloadPage() {
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.generic-error-card {
  @media (max-width: 640px) {
    background-color: #fbfbfb;
    box-shadow: none !important;
  }
}
</style>
